import React from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import PropTypes from 'prop-types'
import Button from '@components/Button'
import { BUTTON_SIZE, BUTTON_TYPE } from '@helpers/constants'

const Popup = (props) => {
  const { children, visible, ctas, onCtaClick, onCloseClick } = props

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className={
            'fixed p-8 bg-white top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 max-w-2xl rounded z-40'
          }
          style={{
            width: 'calc(100% - 4rem)',
          }}
          initial={{ opacity: 0 }}
          animate={{
            opacity: 1,
            transition: {
              ease: 'easeInOut',
              duration: 0.35,
            },
          }}
          exit={{
            opacity: 0,
            transition: {
              ease: 'easeInOut',
              duration: 0.25,
            },
          }}
        >
          <div className='absolute top-4 right-4'>
            <Button
              handleClick={() => {
                onCloseClick()
              }}
              size={BUTTON_SIZE.NO_PADDING}
              icon={'Close'}
            ></Button>
          </div>

          {children}

          {ctas && ctas.length > 0 && (
            <div className={'flex justify-center mt-6'}>
              {ctas.map((cta, index) => {
                const { label, icon = null, to = null } = cta
                return (
                  <Button
                    key={index}
                    type={BUTTON_TYPE.PRIMARY}
                    size={BUTTON_SIZE.LARGE}
                    icon={icon ? icon : null}
                    iconLeft={icon ? true : false}
                    margin
                    handleClick={() => {
                      onCtaClick(to)
                    }}
                  >
                    {label}
                  </Button>
                )
              })}
            </div>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  )
}

Popup.propTypes = {
  children: PropTypes.node.isRequired,
  visible: PropTypes.bool,
  ctas: PropTypes.array,
  onCtaClick: PropTypes.func,
  onCloseClick: PropTypes.func,
}

export default Popup
